<template>
  <div class="p_u_main" ref="activity_scroll" @scroll="activityScroll">
    <div class="p-u-video">
        <video v-if="videoDetail.video_url" id="aboutType1_video" ref="aboutType1_video" class="video" :poster="videoDetail.img_url" controls x5-video-player-type="h5" playsinline webkit-playsinline>
            <source :src="videoDetail.video_url" type="video/mp4">
        </video>
    </div>
    <ul class="p-u-content">
        <li v-for="item in proList" :key="item.id" @click="gotoDetail(item.id)">
            <van-image class="img" round :src="cdnUrl + item.cover_img" alt="" />
            <div class="p-u-desc">
                <p class="van-multi-ellipsis--l2 p-u-tip">{{ item.title }}</p>
                <p class="van-multi-ellipsis--l2">{{ item.jianjie }}</p>
            </div>
        </li>
    </ul>
    <footerLine></footerLine>
  </div>
</template>

<script>
import { getProductList } from '@/api/product'
import { getMenuVideo } from '@/api/label'
import footerLine from '@/components/footerLine'
export default {
     components: {
        footerLine
    },
     data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            page: 1,
            last_page: 0,
            proList: [],
            videoDetail: {}
        }
    },
    created() {
        this.getProList()
        this.getVideo()
    },
    methods: {
        getVideo() {
            let para = {
                mark: '1',
                module: '1',
                type: '1'
            }
            getMenuVideo(para).then(res => {
                res.data[0].img_url = this.cdnUrl + JSON.parse(res.data[0].img_url)[0]
                res.data[0].video_url = this.cdnUrl + JSON.parse(res.data[0].video_url)[0]
                this.videoDetail = res.data[0]
            })
        },
        getProList() {
            let para = {
                page: this.page,
                type: '6'
            }
            getProductList(para).then(res => {
                this.proList.push(...res.data.data)
                this.last_page = res.data.last_page
            })
        },
        gotoDetail(id) {
            this.$router.push({
                name: 'pipStoryDetail',
                query: {
                    id: id
                }
            })
        },
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 25 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.p_u_main {
    height: 100vh;
    overflow: auto;
}
.p-u-video {
    width: rem(343);
    height: rem(159);
    margin: 0 auto;
    margin-top: rem(12);
    border-radius: rem(6);
    // background-color: #ccc;
    .video {
        width: 100%;
        height: rem(159);
    }
}
.p-u-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    li {
        display: flex;
        align-items: center;
        width: rem(343);
        height: rem(100);
        margin-top: rem(16);
        padding-left: rem(6);
        border-radius: rem(6);
        box-shadow: 0px 2px 4px 0px rgba(51,51,51,0.3);
        box-sizing: border-box;
        .img {
            width: rem(171);
            height: rem(89);
            margin-right: rem(14);
            border-radius: rem(6);
        }
        .p-u-desc {
            width: rem(192);
            padding-right: rem(9);
            font-size: rem(12);
            box-sizing: border-box;
            .p-u-tip {
                height: rem(40);
                // margin-top: rem(8);
                margin-bottom: rem(8);
                font-size: rem(14);
                font-weight: bold;
                color: #333333;
            }
        }
    }
}
</style>